import React, {Fragment, useEffect, useRef, useState} from 'react';
import {Menu, Transition} from '@headlessui/react'
import {BsLink45Deg} from 'react-icons/bs'
import {PiTelegramLogoLight} from 'react-icons/pi'
import {AiOutlineWhatsApp} from 'react-icons/ai'
import {AiOutlineInstagram} from 'react-icons/ai'

function ShareButton(props) {
    const [links,setLinks] = useState([
        {
            label:'لینک',
            icon:<BsLink45Deg className='ml-2'/>,
            href:'#'
        },
        {
            label:'تلگرام',
            icon:<PiTelegramLogoLight className='ml-2'/>,
            href:'#'
        },
        {
            label:'واتساپ',
            icon:<AiOutlineWhatsApp className='ml-2'/>,
            href:'#'
        },
        {
            label:'اینستاگرام',
            icon:<AiOutlineInstagram className='ml-2'/>,
            href:'#'
        },
        {
            label:'ایکس',
            icon:<BsLink45Deg className='ml-2'/>,
            href:'#'
        },
        {
            label:'لینکدین',
            icon:<BsLink45Deg className='ml-2'/>,
            href:'#'
        },
    ])

    return (
        <>
            <Menu as="div" className="relative inline-block">
                <div>
                    <Menu.Button
                        className={` inline-flex items-center w-full justify-center rounded-md transition px-4 py-2 text-xs font-medium bg-purple-50 hover:bg-main text-purple-800 hover:text-purple-100`}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
                             stroke="currentColor" className="w-4 h-4 ml-2">
                            <path strokeLinecap="round" strokeLinejoin="round"
                                  d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z"/>
                        </svg>
                        <span>اشتراک گذاری</span>
                    </Menu.Button>
                </div>
                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <Menu.Items
                        className="absolute right-0 mt-2 w-32 origin-top-right rounded-md bg-purple-50 p-4">
                        <div className="flex flex-col items-start space-y-2 text-sm">
                            {links.map((link,index) =>
                                <Menu.Item
                                    as="a"
                                    key={link.href}
                                    href={link.href}
                                    className="flex flex-row"
                                >
                                    {link.icon}
                                    {link.label}
                                </Menu.Item>
                            )}
                        </div>
                    </Menu.Items>
                </Transition>
            </Menu>
        </>
    );
}

export default ShareButton;